import { JSX } from 'react';
import './closeButton.css';

const AddButton = ({clickFunction}:{ clickFunction: () => void }): JSX.Element => {
    return (
        <button className='close-button' onClick={() => clickFunction()}>
            <span>x</span>
        </button>
    ); 
};
      
export default AddButton;